import axios, { AxiosResponse } from "axios";

import { MKS_BACKEND_URL } from "src/utils/env";

enum Endpoint {
    logIn = "login",
    register = "register",
    registration_form = "registration-form",
    verify_email = "reset-password",
    reset_password = "forgot-password",
}

export class AuthService {
    private static readonly BASE_URL = MKS_BACKEND_URL;

    public static async login(email: string, password: string): Promise<AxiosResponse> {
        return axios.post([AuthService.BASE_URL, Endpoint.logIn].join("/"), {
            email,
            password
        }, { withCredentials: true });
    }

    public static async register(email: string, mobileNo: string, password: string, role: 'USER'): Promise<AxiosResponse> {
        // Map frontend role 'USER' to backend enum name 'ROLE_USER' and send as a list
        const backendRole = role === 'USER' ? 'ROLE_USER' : role;
        const roles = [backendRole];
        return axios.post([AuthService.BASE_URL, Endpoint.register].join("/"), {
            email,
            mobileNo,
            password,
            roles,
        });
    }

    public static async registrationForm(
        email: string,
        mobileNo: string,
        saveStatus: number,
        registrationData: any
    ): Promise<AxiosResponse> {

        return axios.post(
            [AuthService.BASE_URL, Endpoint.registration_form].join("/"),
            { email, mobileNo, saveStatus, registrationData }
        );
    }

    public static async refreshToken(): Promise<AxiosResponse> {
        return axios.post([AuthService.BASE_URL, 'refresh-token'].join("/"), {}, { withCredentials: true });
    }

    public static async logout(): Promise<AxiosResponse> {
        return axios.post([AuthService.BASE_URL, 'logout'].join("/"), {}, { withCredentials: true });
    }
    
    public static async verifyEmail(email: string): Promise<AxiosResponse> {
        return axios.post([AuthService.BASE_URL, Endpoint.verify_email].join("/") + `?email=${email}`);
    }

    public static async resetPassword(email: string, newPassword: string, tempPassword: string): Promise<AxiosResponse> {
        return axios.put([AuthService.BASE_URL, Endpoint.reset_password].join("/"), {
            email,
            newPassword,
            oldPassword : tempPassword
        });
    }
}
